export default {
  "dailyRebateAdmin.thead.index": "#NO",
  "dailyRebateAdmin.thead.gameType": "游戏类型",
  "dailyRebateAdmin.thead.providerId": "游戏厂商",
  "dailyRebateAdmin.thead.rebateConfig": "返现配置",
  "dailyRebateAdmin.thead.createdAt": "创建时间",
  "dailyRebateAdmin.thead.updatedAt": "更新新时间",
  "dailyRebateAdmin.thead.status": "状态",

  "dailyRebateAdmin.add": "新增",
  "dailyRebateAdmin.edit": "编辑",
  "dailyRebateAdmin.details": "详情",
  "dailyRebateAdmin.delete": "删除",
  "dailyRebateAdmin.thead.action": "操作",
  "dailyRebateAdmin.showConfig": "查看配置",
};
